import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";

export default function ResetPasswordDialog({ target, value, setValue, onClose, onConfirm }) {
  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="gf-sharp border-zinc-200">
        <DialogHeader>
          <DialogTitle className="font-display font-bold tracking-tight">Reset password</DialogTitle>
          <DialogDescription>For {target?.email}</DialogDescription>
        </DialogHeader>
        <Label className="gf-overline">New password</Label>
        <Input
          type="password"
          data-testid="admin-reset-pw-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="gf-sharp mt-2 border-zinc-300 bg-white"
          placeholder="min 6 chars"
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="gf-sharp border-zinc-300 uppercase font-bold tracking-wide">Cancel</Button>
          <Button onClick={onConfirm} data-testid="admin-reset-pw-confirm" className="gf-sharp bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-wide">
            Reset password
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
